import {
	Select,
	Text,
	Upload,
	Number,
	FormGroupInterface,
	FORM_TYPE,
	VALIDATION_TYPE,
	DFormGroup,
} from "../../types";

export function getForm(data: any = {}, on: any = {}, required: any = {}) {
	const addSectorTarget = new DFormGroup({
		label: "",
		submitText: (data.label && data.label.submit) || "Submit",
		cancelText: (data.label && data.label.cancel) || "Cancel",
		type: FORM_TYPE.MODAL,
		row: false,
		forms: [
			{
				formElements: [
					new Text("Training Centre Name:", {
						name: "trainingCentreName",
						silentRequired: true,
						validationType: VALIDATION_TYPE.TC_NAME,
						readOnly: true,
						value: data.trainingCentreName,
						hide: !data.trainingCentreName,
					}),
					new Select("Sector:", data.sectors, {
						required: true,
						placeholder: "Please Select Sector",
						name: "sector",
						// silentRequired: true,
						showAstrisk: true,
						onChange: on.sectorChange,
					}),
					new Select("Course:", data.courses, {
						required: true,
						name: "course",
						placeholder: "Please Select Course",
						showAstrisk: true,
					}),
					new Text("Target:", {
						required: true,
						placeholder: "Enter Target",
						name: "target",
						silentRequired: false,
						min: 10,
						max: 100000,
					}),
				],
			},
		],
	});
	return addSectorTarget;
}
